import { useState } from 'react'
import { Link, router, usePage } from '@inertiajs/react'
import { Button } from '@/components/ui/Button'

interface Props {
  reset_password_token: string
  errors?: string[]
}

export default function ResetPassword() {
  const { props } = usePage<Props>()
  const [password, setPassword] = useState('')
  const [confirmation, setConfirmation] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    router.put('/users/password', {
      user: {
        reset_password_token: props.reset_password_token,
        password,
        password_confirmation: confirmation,
      },
    })
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="h-14 flex items-center px-6">
        <Link href="/" className="font-bold text-xl text-gray-900">GetCasts</Link>
      </header>

      <div className="flex-1 flex items-center justify-center px-4">
        <div className="bg-white rounded-2xl border border-gray-200 p-8 w-full max-w-md shadow-sm">
          <h1 className="text-2xl font-bold text-gray-900 mb-1">Set new password</h1>
          <p className="text-sm text-gray-500 mb-6">Choose a strong password.</p>

          {props.errors && props.errors.length > 0 && (
            <div className="mb-4 rounded-xl bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700">
              {props.errors[0]}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">New password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                minLength={6}
                className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-brand/30"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Confirm password</label>
              <input
                type="password"
                value={confirmation}
                onChange={e => setConfirmation(e.target.value)}
                placeholder="••••••••"
                required
                minLength={6}
                className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-brand/30"
              />
            </div>
            <Button className="w-full rounded-xl py-2.5" type="submit">
              Reset password
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}
